import React from 'react'

export default class DataSourcePresenterColumns extends React.Component {
  constructor(props) {
    super(props)
  };

  render() {
    if (this.props.activeTab === 'columns') {
      return (
        <div className="data-table report-table chart-wrapper" style={{width: '80%'}}>
          <table className="table" style={{ margin: 'auto', border: '1px solid #dddddd' }}>
            {this.renderTableHead()}
            {this.renderTableBody()}
          </table>
        </div>
      );
    } else { return null }
  };


  renderTableHead(){
    return(
      <thead>
        <tr style={{backgroundColor:'white'}}>
          <th style={{ position: "sticky", backgroundColor: 'white', borderBottom: '2px solid #dddddd'}}>{I18n.t('column')}</th>
          <th style={{ position: "sticky", backgroundColor: 'white', borderBottom: '2px solid #dddddd'}}>{I18n.t('data_type')}</th>
          <th style={{ position: "sticky", backgroundColor: 'white', borderBottom: '2px solid #dddddd'}}>{I18n.t('segment_on')}</th>
          <th style={{ position: "sticky", backgroundColor: 'white', borderBottom: '2px solid #dddddd' }}><label>{I18n.t('status')}</label></th>
        </tr>    
      </thead>
    )
  };

  renderTableBody(){
    var rows = this.props.data_source.source_details.map((detail, idx) =>{
      return (
        <tr key={detail.id} style={idx % 2 === 1 ? { backgroundColor: 'white' } : null}>
          <td>{I18n.t(detail.display_name)}</td>
          <td>{detail.data_type === 'date' ? I18n.t('date_word'): I18n.t(detail.data_type)}</td>
          <td>{detail.segment_on_model && detail.segment_on_column ? (`${detail.segment_on_model}/${detail.segment_on_column.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}`): I18n.t('na')}</td>
          <td style={{width:'20%'}}>{I18n.t(detail.status)}</td>
        </tr>
      )
    })
    return(
      <tbody>
        {rows}
      </tbody>
    );
  };
};